import * as yup from 'yup'

export class PersonAddressDto {
  addressGuid?: string = undefined
  addressNickname?: string = undefined
  email?: string = undefined
  phone?: string = undefined
  address1?: string = undefined
  address2?: string = undefined
  city?: string = undefined
  county?: string = undefined
  stateProvince?: string = undefined
  postalCode?: string = undefined
  country?: string = undefined
  countryCode?: string = undefined
  isActive?: boolean = true
  isHomeAddress?: boolean = false
  isWorkAddress?: boolean = false
  isDeclarantAddress?: boolean = false
  isTitleClerkAddress?: boolean = false
}

export const personAddressValidationSchema = yup.object({
  addressNickname: yup
    .string()
    .max(200, 'Address Nickname cannot be more than 200 characters.')
    .required('Address Nickname is required.'),
  phone: yup.string().max(200, 'Phone cannot be more than 200 characters.').nullable(),
  email: yup.string().max(320, 'Email cannot be more than 320 characters.').nullable(),
  address1: yup.string().max(200, 'Address 1 cannot be more than 200 characters.').required('Address 1 is required.'),
  address2: yup.string().max(200, 'Address 2 cannot be more than 200 characters.').nullable(),
  city: yup.string().max(200, 'City cannot be more than 200 characters.').required('City is required.'),
  county: yup.string().max(200, 'County cannot be more than 200 characters.').nullable(),
  stateProvince: yup
    .string()
    .max(200, 'State / Province cannot be more than 200 characters.')
    .required('State / Province is required.'),
  postalCode: yup.string().max(200, 'Postal Code cannot be more than 200 characters.').required('Postal Code is required.'),
  country: yup.string().max(200, 'Country cannot be more than 200 characters.').required('Country is required.'),
  isActive: yup.boolean(),
  isHomeAddress: yup.boolean(),
  isWorkAddress: yup.boolean(),
  isDeclarantAddress: yup.boolean(),
  isTitleClerkAddress: yup.boolean()
})
